module.exports = __webpack_public_path__ + "img/bind_success_icon.3f950a32.png";